import { BillingGridType } from '@/modules/billing-module/components/grid/config/datasources/billing-grid-datasource-factory'
import { BillingCaseCategory } from '@/api/services/billing/case-grid/billing-case.service'
import { BillingAppliedBillableConceptCategory } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.service'
import { BillingCopaymentsCategory } from '@/modules/billing-module/components/grid/config/datasources/impl/billing-grid-copayments.datasource'
import { BillableDeliveryNoteStatus } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { InvoiceStatus } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoicePaymentStatus } from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { InvoiceReceiptStatus } from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'
import { HelperUtils } from '@/shared/util/helper-utils'
import { BillingOperation } from '@/api/operations/models/billing-operation'

export const billingSidebarOptions = () => ({
    sideBarName: 'BillingSideBar',
    expanded: [
        {
            id: 'billing.sidebar.categories',
            label: 'accounting.sidebar.categories',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'billing.sidebar.cases',
                    label: 'accounting.sidebar.cases',
                    icon: ['fal', 'chart-network'],
                    uicomponent: 'uicomponent.billing.grid.cases',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS),
                    data: {
                        gridType: BillingGridType.CASES
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.cases.automationError',
                            label: 'accounting.sidebar.cases.automationError',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_AUTOMATIC_BILLABLE_CONFLICTS
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.withoutConcepts',
                            label: 'accounting.sidebar.cases.withoutConcepts',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_NO_CONCEPTS
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.onlyConcepts',
                            label: 'accounting.sidebar.cases.onlyConcepts',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_CONCEPTS_WITHOUT_CUSTOMER_AND_RATE
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.conceptsAndClients',
                            label: 'accounting.sidebar.cases.conceptsAndClients',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_CONCEPTS_WITH_ONLY_CUSTOMER
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.conceptsAndRates',
                            label: 'accounting.sidebar.cases.conceptsAndRates',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_CONCEPTS_WITH_ONLY_RATE
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.unauthorizedConcepts',
                            label: 'accounting.sidebar.cases.unauthorizedConcepts',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS
                            }
                        },
                        {
                            id: 'billing.sidebar.cases.notToInvoiceConcepts',
                            label: 'accounting.sidebar.cases.notToInvoiceConcepts',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCaseCategory.HAS_CONCEPTS_NOT_TO_BE_ADDED_TO_INVOICE
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.concepts',
                    label: 'accounting.sidebar.concepts',
                    icon: ['fal', 'calculator'],
                    uicomponent: 'uicomponent.billing.grid.concepts',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS),
                    data: {
                        gridType: BillingGridType.CONCEPTS
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.concepts.withoutClient',
                            label: 'accounting.sidebar.concepts.withoutClient',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingAppliedBillableConceptCategory.HAS_NO_CUSTOMER
                            }
                        },
                        {
                            id: 'billing.sidebar.concepts.withClient',
                            label: 'accounting.sidebar.concepts.withClient',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingAppliedBillableConceptCategory.HAS_CUSTOMER
                            }
                        },
                        {
                            id: 'billing.sidebar.concepts.withErrors',
                            label: 'accounting.sidebar.concepts.withErrors',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingAppliedBillableConceptCategory.HAS_ERRORS
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.copayments',
                    label: 'accounting.sidebar.copayments',
                    icon: ['fal', 'comments-alt-dollar'],
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS),
                    data: {
                        gridType: BillingGridType.COPAYMENTS
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.copayments.withoutClient',
                            label: 'accounting.sidebar.copayments.withoutClient',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCopaymentsCategory.HAS_NO_CUSTOMER
                            }
                        },
                        {
                            id: 'accounting.sidebar.copayments.noValued',
                            label: 'accounting.sidebar.copayments.noValued',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCopaymentsCategory.HAS_NO_VALUE
                            }
                        },
                        {
                            id: 'billing.sidebar.copayments.value',
                            label: 'accounting.sidebar.copayments.valued',
                            operations: [BillingOperation.BILLABLE_CONCEPTS_AND_CASES_ACCESS],
                            data: {
                                category: BillingCopaymentsCategory.HAS_VALUE
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.deliveryNotes',
                    label: 'accounting.sidebar.deliveryNotes',
                    icon: ['fal', 'ballot'],
                    uicomponent: 'uicomponent.billing.grid.deliveryNotes',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.DELIVERY_NOTES_ACCESS),
                    data: {
                        gridType: BillingGridType.DELIVERY_NOTES
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.deliveryNotes.generated',
                            label: 'accounting.sidebar.deliveryNotes.generated',
                            operations: [BillingOperation.DELIVERY_NOTES_ACCESS],
                            data: {
                                category: BillableDeliveryNoteStatus.GENERATED
                            }
                        },
                        {
                            id: 'billing.sidebar.deliveryNotes.issued',
                            label: 'accounting.sidebar.deliveryNotes.issued',
                            operations: [BillingOperation.DELIVERY_NOTES_ACCESS],
                            data: {
                                category: BillableDeliveryNoteStatus.ISSUED
                            }
                        },
                        {
                            id: 'billing.sidebar.deliveryNotes.verified',
                            label: 'accounting.sidebar.deliveryNotes.verified',
                            operations: [BillingOperation.DELIVERY_NOTES_ACCESS],
                            data: {
                                category: BillableDeliveryNoteStatus.VERIFIED
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.invoices',
                    label: 'accounting.sidebar.invoices',
                    icon: ['fal', 'file-invoice-dollar'],
                    uicomponent: 'uicomponent.billing.grid.invoices',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLING_INVOICES_ACCESS),
                    data: {
                        gridType: BillingGridType.INVOICES
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.invoices.generated',
                            label: 'accounting.sidebar.invoices.generated',
                            operations: [BillingOperation.BILLING_INVOICES_ACCESS],
                            data: {
                                category: InvoiceStatus.GENERATED
                            }
                        },
                        {
                            id: 'billing.sidebar.invoices.cancelled',
                            label: 'accounting.sidebar.invoices.cancelled',
                            operations: [BillingOperation.BILLING_INVOICES_ACCESS],
                            data: {
                                category: InvoiceStatus.CANCELLED
                            }
                        },
                        {
                            id: 'billing.sidebar.invoices.verified',
                            label: 'accounting.sidebar.invoices.verified',
                            operations: [BillingOperation.BILLING_INVOICES_ACCESS],
                            data: {
                                category: InvoiceStatus.VERIFIED
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.invoicePayments',
                    label: 'accounting.sidebar.invoicePayments',
                    icon: ['fal', 'credit-card-front'],
                    uicomponent: 'uicomponent.billing.grid.invoicePayments',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLING_PAYMENTS_ACCESS),
                    data: {
                        gridType: BillingGridType.INVOICE_PAYMENTS
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.invoicePayments.generated',
                            label: 'accounting.sidebar.invoicePayments.generated',
                            operations: [BillingOperation.BILLING_PAYMENTS_ACCESS],
                            data: {
                                category: InvoicePaymentStatus.GENERATED
                            }
                        },
                        {
                            id: 'billing.sidebar.invoicePayments.cancelled',
                            label: 'accounting.sidebar.invoicePayments.cancelled',
                            operations: [BillingOperation.BILLING_PAYMENTS_ACCESS],
                            data: {
                                category: InvoicePaymentStatus.CANCELLED
                            }
                        },
                        {
                            id: 'billing.sidebar.invoicePayments.verified',
                            label: 'accounting.sidebar.invoicePayments.verified',
                            operations: [BillingOperation.BILLING_PAYMENTS_ACCESS],
                            data: {
                                category: InvoicePaymentStatus.VERIFIED
                            }
                        }
                    ]
                },
                {
                    id: 'billing.sidebar.invoiceReceipts',
                    label: 'accounting.sidebar.invoiceReceipts',
                    icon: ['fal', 'envelope-open-dollar'],
                    uicomponent: 'uicomponent.billing.grid.invoiceReceipts',
                    hide: !HelperUtils.hasOperationInCurrentLaboratory(BillingOperation.BILLING_RECEIPTS_ACCESS),
                    data: {
                        gridType: BillingGridType.INVOICE_RECEIPTS
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'billing.sidebar.invoiceReceipts.generated',
                            label: 'accounting.sidebar.invoiceReceipts.generated',
                            operations: [BillingOperation.BILLING_RECEIPTS_ACCESS],
                            data: {
                                category: InvoiceReceiptStatus.GENERATED
                            }
                        },
                        {
                            id: 'billing.sidebar.invoiceReceipts.verified',
                            label: 'accounting.sidebar.invoiceReceipts.verified',
                            operations: [BillingOperation.BILLING_RECEIPTS_ACCESS],
                            data: {
                                category: InvoiceReceiptStatus.VERIFIED
                            }
                        }
                    ]
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'calculator-alt'],
        name: 'accounting.sidebar.title'
    }
})
